__turbopack_context__.v({
  "afisha-selection-chevron--big": "MediaCard-module-sass-module__LlTxxG__afisha-selection-chevron--big",
  "afisha-selection-chevron--medium": "MediaCard-module-sass-module__LlTxxG__afisha-selection-chevron--medium",
  "card": "MediaCard-module-sass-module__LlTxxG__card",
  "card-date": "MediaCard-module-sass-module__LlTxxG__card-date",
  "card-description": "MediaCard-module-sass-module__LlTxxG__card-description",
  "card-extra": "MediaCard-module-sass-module__LlTxxG__card-extra",
  "card-image-link": "MediaCard-module-sass-module__LlTxxG__card-image-link",
  "card-like-button": "MediaCard-module-sass-module__LlTxxG__card-like-button",
  "card-media-type": "MediaCard-module-sass-module__LlTxxG__card-media-type",
  "favorite": "MediaCard-module-sass-module__LlTxxG__favorite",
  "image": "MediaCard-module-sass-module__LlTxxG__image",
  "image-wrapper": "MediaCard-module-sass-module__LlTxxG__image-wrapper",
  "promo": "MediaCard-module-sass-module__LlTxxG__promo",
  "skeleton-card": "MediaCard-module-sass-module__LlTxxG__skeleton-card",
  "skeleton-image": "MediaCard-module-sass-module__LlTxxG__skeleton-image",
  "skeleton-text": "MediaCard-module-sass-module__LlTxxG__skeleton-text",
  "skeleton-text--1": "MediaCard-module-sass-module__LlTxxG__skeleton-text--1",
  "skeleton-text--2": "MediaCard-module-sass-module__LlTxxG__skeleton-text--2",
  "skeleton-text--3": "MediaCard-module-sass-module__LlTxxG__skeleton-text--3",
});
